export default "/images/98782159a358b101ea47067e5316ee7a.avif";